export const checkoutUrl =
  'https://el-kit-del-acompanante.impultienda.ar/checkout'

export const pricing = {
  main: '$19.990',
  crossed: '$49.990',
  bonusesValue: '$9.990',
  tomoValue: '$9.990',
  upsell: '$9.990',
}
